"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = directoryDataReducer;

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _InitialFilterParams = _interopRequireDefault(require("../constants/InitialFilterParams"));

var _utils = require("../utils/utils");

var initialState = (0, _immutable.fromJS)({
  goodFiltersAndPage: _InitialFilterParams.default,
  numGoodsMatchingFilterCriteria: 0,
  requestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  goods: []
});

function directoryDataReducer() {
  var directoryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FILTERS_OR_PAGE_UPDATED:
      return directoryData.set('goodFiltersAndPage', (0, _utils.mergeGoodFiltersAndPage)(directoryData.get('goodFiltersAndPage'), (0, _utils.resetNotApplicableFilters)(directoryData.get('goodFiltersAndPage'), action.payload)));

    case _ActionTypes.default.GOODS_REQUESTED_ON_PAGE_LOAD:
      if (action.error) {
        return directoryData.set('requestStatus', _RequestStatusTypes.default.FAILED);
      }

      return directoryData.set('requestStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.GOODS_RECEIVED:
      return directoryData.merge({
        requestStatus: _RequestStatusTypes.default.SUCCEEDED,
        numGoodsMatchingFilterCriteria: action.payload.total,
        goods: action.payload.result
      });

    default:
      return directoryData;
  }
}

module.exports = exports.default;